import { http_client } from '@/plugins/http_client';

const url = 'api/solicitudes/renuncia';

const getRenuncias = async (codigo_actor,filtros={}) => await http_client(`${url}/aprobacion/${codigo_actor}`,filtros)
const getRenunciasDinarh = async (filtros={}) => await http_client(`${url}/dinarh`,filtros)
const AprobarRenuncias = async (id) => await http_client(`${url}/jefe-unidad/aprobar/${id}`, {}, 'POST')
const DenegarRenuncias = async (id, motivoRechazo = {}) => await http_client(`${url}/jefe-unidad/denegar/${id}`, motivoRechazo, 'POST')
const completarRenuncias = async (id, fechaEnvio = {}) => await http_client(`${url}/rrhh/notificar-planilla/${id}`, fechaEnvio, 'POST')
const RenunciaUfi = async (id) => await http_client(`${url}/ufi/confirmar-suspension/${id}`, {}, 'POST')
const generarPdfRenuncia = async (id_renuncia) => await http_client(`${url}/get-acuerdo/${id_renuncia}`)
const verificarEmpleado = async () => await http_client(`${url}/verificar-empleado`, {})


export default {
  getRenuncias,
  AprobarRenuncias,
  DenegarRenuncias,
  completarRenuncias,
  RenunciaUfi,
  generarPdfRenuncia,
  verificarEmpleado,
  getRenunciasDinarh,
}